/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { dateToFormat, formatDateHour, getMonthRange, getWeekOfDate } from '../../../utils/date';
import { ColCard, Row } from '../../../components/ContentLayout';
import Calendar from '../../../components/Calendar/Calendar';
import { ControlTable } from '../../../components/Table';
import { isEmpty, isNumber } from 'lodash';
import systemAlert from '../../../utils/systemAlert';
import { toast } from '../../../utils/toast';
import { editTaxpayerSchedule, getTaxpayerSchedules, removeTaxpayerSchedule, taxpayerScheduleCategoryList } from '../../../apis/tax-portal/taxpayer';
import Button from '../../Button';
import TaxCompanyScheduleDetail from './TaxCompanyScheduleDetail';
import useForm from '../../../hooks/useForm';
import Icon from '../../Icon';
import CommentIcon from "../../../assets/images/icon/comment-icon.svg";
import { custodianPreview } from '../../../utils/custodian';


const TaxCompanySchedule = (props) => {
  const {
    taxContactType,
    company,
    companies,
    user,
  } = useSelector(
    (store) => ({
      user: store.Profile.user,
      taxContactType: store.TaxPortal.taxContactType,
      company: store.Profile.company,
      companies: store.Data.companies,
    }),
    shallowEqual
  );
  const calendarRef = useRef(null);
  const [, setSelectedSchedule] = useState(null);
  const [dateParams, setDateParams] = useState({
    from: "",
    to: "",
  });

  const [event, setEvent] = useState([]);

  const [schedule, setSchedule] = useState(null);
  const [toggle, setToggle] = useState(false);
  const [formType, setFormType] = useState("create");
  const [isLoading, setIsLoading] = useState(false);
  const [myCompany, setMyCompany] = useState({});

  const [rowBtnConfig, setRowBtnConfig] = useState({});
  const [categories, setCategories] = useState([]);


  const [fields, setFields] = useState([]);
  useEffect(() => {
    if (!isEmpty(company) && !isEmpty(companies)) {

      const managerCompany = companies.find((com) => com.companyIdx === user.managerCompanyIdx);
      setMyCompany(managerCompany);
      taxpayerScheduleCategoryList({ search: { isActive: true } }).then(res => {
        setCategories(res.rows);
      }).catch((err) => console.error(err.response));
    }
  }, [company, companies]);

  useEffect(() => {
    !isEmpty(taxContactType) && !isEmpty(dateParams.from) && !isEmpty(myCompany) && submit();
  }, [dateParams, taxContactType, myCompany]);

  const submit = async () => {
    setIsLoading(true);
    getTaxpayerSchedules(myCompany?.companyIdx, {
      range: { date: dateParams },
      taxSearchType: taxContactType,
      order: [{ createdTime: "desc" }],

    })
      .then((res) => {
        setList([]);
        setTotal(0);

        const { schedules = [], comment = {} } = res.data;
        setEvent(schedules.map((data) => {
          const weekOfDate = getWeekOfDate(data.date);
          return {
            title: data.title + " [" + (data.completed === 1 ? "처리" : "미처리") + "]",
            date: data.date,
            data: { ...data, comments: comment.listByPost.find(c => c.postIdx === data.idx) },
            categoryColor: data.category?.color || "",
            tooltip: weekOfDate === 0 ? "right" : weekOfDate === 6 ? "left" : "top",
          };
        }));
      })
      .catch((err) => {
        console.error(err.response);
      }).finally(() => setIsLoading(false));
  };

  const listSubmit = (form) => {
    const { page = 0, limit } = form;
    const list = event.slice(page * limit, (page + 1) * limit);
    setList(list);
    setTotal(event.length);
  };

  const {
    form,
    setSubmit,
    list,
    setList,
    total,
    setTotal,
    page,
    setPage,
    limit, setLimit,
  } = useForm({ limit: 10, offset: 0 });

  useEffect(() => {
    if (!isEmpty(event)) {
      setSubmit(listSubmit);
      listSubmit(form);
    }
  }, [event]);

  const clickEvent = useCallback((params) => {
    setSchedule(params.event.extendedProps.data);
    setFormType("view");
    setToggle(true);
    console.log("??");


  }, [setSelectedSchedule]);

  const onRowClick = ({ data }, e) => {
    // switch 관련 className 체크

    if (
      !e.target.classList.contains('slider') &&
      !e.target.classList.contains('switch-blue') &&
      e.target?.tagName !== "SPAN"
    ) {
      setSchedule(data);
      setFormType("view");
      setToggle(true);
    }

  };


  const onMonthChage = (date) => {
    const from = dateToFormat(getMonthRange(1, true, date.view.currentStart).from);
    const to = dateToFormat(getMonthRange(0, true, date.view.currentEnd).to);

    setDateParams({
      from,
      to,
    });
  };

  useEffect(() => {
    if (!isEmpty(event)) {
      setRowBtnConfig({
        rowButtons: [
          {
            label: "수정",
            type: "edit",
            action: ({ data }) => {
              setSchedule(data);
              setFormType("modify");
              setToggle(true);
            },

          },
          {
            label: "삭제",
            type: "delete",
            action: ({ data }) => {
              systemAlert(`"${data?.title}" 일정을 삭제하시겠습니까?`, {
                buttons: [
                  {
                    color: 'text',
                    label: '취소'
                  },
                  {
                    label: '삭제',
                    color: 'red',
                    onClick: () => {
                      setIsLoading(true);
                      removeTaxpayerSchedule(myCompany.companyIdx, data.idx)
                        .then((res) => {
                          toast.success("삭제가 완료되었습니다.");
                          submit();
                        })
                        .finally(() => {
                          setIsLoading(false);
                        });
                    }
                  }
                ]
              });
            },
          },
        ],
      });
    }

    const _fields = [
      {
        title: "노출색상", key: "categoryColor", onValue: (v) => {
          return (
            <span style={{
              display: "inline-block",
              background: v,
              width: "15px",
              height: "15px",
              borderRadius: "50%",
            }} />
          );
        }
      },
      // {
      //   title: "카테고리", key: "category", onValue: (v, _f, d) => {
      //     console.log(d);
      //   }
      // },
      { title: "작업일", key: "data.date", onValue: (d) => dateToFormat(d, formatDateHour) },
      { title: "제목", key: "data.title" },
      {
        title: "처리여부",
        key: "completed",
        width: "80px",
        type: "switch",
        // onValue: (d) => d ? "처리" : "미처리"
        checked: (d) => {
          return d?.data?.completed;
        },
        onChange: (e, { data }) => {
          setIsLoading(true);
          editTaxpayerSchedule(company.managerCompanyIdx, data.idx, { completed: +e.target.checked })
            .then((res) => {
              toast.success('수정되었습니다.');
              submit();
            })
            .finally(() => setIsLoading(false));

        }
      },
      {
        title: "회사명", key: "data.management", onValue: (v) => {
          return (
            v ? (
              <span
                onClick={() => isNumber(v.idx) && custodianPreview(v.idx)}
              >{v.companyName}</span>
            ) : "-"

          );
        }
      },
      { title: "담당자", width: "80px", key: "data.employee.name" },
      {
        title: "",
        key: "data.comments",
        onValue: (value) => {
          return (
            !isEmpty(value) ? (
              <>
                <Icon src={CommentIcon} />
                <span className="ml-4 font-bold">{value.count}</span>
              </>
            ) : (<></>)
          );
        }
      },
    ];
    setFields(_fields);
  }, [event]);

  return (
    <div className="tax-portal-schedule">
      <div className="tax-portal-schedule-calendar-header">
        <div className="categories-wrap">
          {categories && categories.map((item, idx) => {
            return (
              <span className="category-item mr-10" key={idx}>
                <span
                  className="mr-5"
                  style={{
                    background: item.color,
                  }}
                />
                {item.name}
              </span>
            );
          })}
        </div>
        <div className="mb-10 header-button-wrap">

          <Button
            label="일정 등록"
            action={() => {
              setToggle(true);
              setSchedule({});
              setFormType("create");
            }}
          />
        </div>
      </div>
      <Row
        style={{ minWidth: "1000px" }}
      >
        <ColCard
          style={{
            maxWidth: "40%",
          }}
          cardBody={{ className: "padding-0" }}>
          <Calendar
            forwardedRef={calendarRef}
            event={event}
            onMonthChage={onMonthChage}
            eventClick={clickEvent}
            type={"tax-portal"}
            className="tax-portal-calendar tooltip-over"
          />
        </ColCard>

        <ColCard
          style={{ width: "60%" }}
          cardBody={{ className: "padding-0" }}
        >
          <ControlTable
            className={"mb-0"}
            isHideControlHeader
            fields={fields}
            // list={event}

            list={list}
            setList={setList}
            total={total}
            setTotal={setTotal}
            page={page}
            setPage={setPage}
            limit={limit}
            setLimit={setLimit}
            isLoading={isLoading}
            rowBtn={rowBtnConfig}
            onSelect={onRowClick}
          />
        </ColCard>
      </Row>
      <TaxCompanyScheduleDetail
        managerCompany={myCompany}
        schedule={schedule}
        setSchedule={setSchedule}
        toggle={toggle}
        setToggle={setToggle}
        formType={formType}
        setFormType={setFormType}
        submit={submit}
      />
    </div >
  );
};

export default TaxCompanySchedule;